// extracted by mini-css-extract-plugin
module.exports = {"main":"ApplyCode_main__G1qce","input_div":"ApplyCode_input_div__1HJzV","input":"ApplyCode_input__9mFdG","apply_button":"ApplyCode_apply_button__1uUMf"};